import type { SeasonFilterParams, SeasonTransformed } from "../types";

const filterSeasons = (seasons: SeasonTransformed[], filters: SeasonFilterParams): SeasonTransformed[] =>
  seasons.filter(({ nameLocal, status, ageGroup, competitionId, gender }) => {
    if (filters.status && status !== filters.status) {
      return false;
    }
    if (filters.ageGroup && ageGroup !== filters.ageGroup) {
      return false;
    }
    if (filters.gender && gender !== filters.gender) {
      return false;
    }
    if (filters.competitionId && competitionId !== filters.competitionId) {
      return false;
    }
    if (filters.searchText && !nameLocal?.toLowerCase()?.includes(filters.searchText.toLowerCase())) {
      return false;
    }
    return true;
  });

export default filterSeasons;
